import { render } from "./ListCompanies.vue?vue&type=template&id=44996399"
import script from "./ListCompanies.vue?vue&type=script&lang=js"
export * from "./ListCompanies.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__